import create from 'zustand'

type UrlParams = {
  date: string | null
  bfs: string | null
}

const queryString = window.location.search
const params = new URLSearchParams(queryString)
const date = params.get('date')
const bfs = params.get('bfs')

export const useStore = create(set => ({
  urlParams: {
    date: date,
    bfs: bfs
  },
  setUrlParams: params =>
    set(state => ({ urlParams: { ...state.urlParams, ...params } }))
}))
